import { render } from "./ReaderConfig.vue?vue&type=template&id=378ae262"
import script from "./ReaderConfig.vue?vue&type=script&lang=js"
export * from "./ReaderConfig.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__